





































































































import { Component, Vue, Emit, Prop, Ref } from "vue-property-decorator";
import Site from "@/models/site";
import FormValidations from "@/helpers/validations";
import { Form } from "@/models/general";
import { LayoutModule } from "@/store/layout";
import AvailabilityBuilder from "./AvailabilityBuilder.vue";

@Component({ components: { AvailabilityBuilder } })
export default class SiteForm extends Vue {
  @Prop() initialSite?: Site;
  @Ref("form") form!: Form;

  site: Site = new Site();
  formValidations = new FormValidations();
  loading = false;

  get isLoading(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  created(): void {
    if (this.initialSite) this.site = new Site(this.initialSite);
  }

  validate(): void {
    const validForm = this.form.validate();
    validForm ? this.save() : null;
  }

  @Emit()
  save(): Site {
    return this.site;
  }
  @Emit()
  cancel(): null {
    return null;
  }

  loadLogo(e: File): void {
    if (e) {
      const reader = new FileReader();
      this.loading = true;
      reader.readAsDataURL(e);
      reader.onload = () => {
        this.loading = false;
        this.site.logo = reader.result ? reader.result.toString() : "";
      };
    } else {
      this.site.logo = undefined;
    }
  }
}
